import styled, { css } from 'styled-components';

const Link = styled.a(
  ({ theme }) => css`
    color: ${theme.colors.gbrand500};
    cursor: pointer;
    text-decoration: none;
  `
);

export default Link;
